module.exports = __webpack_public_path__ + "img/vcontroller-show-btn1.04b617e4.png";